import { OrganizationState } from './organization.types';
import {
  fetchOrganizationUsersWithRolesSuccess,
  FETCH_ORGANIZATION_USERS_WITH_ROLES_API_SUCCESS,
  searchHubspotCompaniesFailed,
  searchHubspotCompaniesRequested,
  searchHubspotCompaniesSuccess,
  SEARCH_HUBSPOT_COMPANIES_STORE_KEY,
} from './organization.actions';

const initialState: OrganizationState = {
  hubspotCompanySearchResults: [],
  organizationUsers: [],
};

export default (
  state = initialState,
  action:
    | ReturnType<typeof fetchOrganizationUsersWithRolesSuccess>
    | ReturnType<typeof searchHubspotCompaniesRequested>
    | ReturnType<typeof searchHubspotCompaniesSuccess>
    | ReturnType<typeof searchHubspotCompaniesFailed>,
): OrganizationState => {
  switch (action.type) {
    case `${SEARCH_HUBSPOT_COMPANIES_STORE_KEY}_API_REQUESTED`:
    case `${SEARCH_HUBSPOT_COMPANIES_STORE_KEY}_API_FAILED`:
      return {
        ...state,
        hubspotCompanySearchResults: [],
      };
    case `${SEARCH_HUBSPOT_COMPANIES_STORE_KEY}_API_SUCCESS`:
      return {
        ...state,
        hubspotCompanySearchResults: action.payload,
      };
    case FETCH_ORGANIZATION_USERS_WITH_ROLES_API_SUCCESS:
      return {
        ...state,
        organizationUsers: action.payload,
      };
    default:
      return state;
  }
};
